export const API_URL = 'http://localhost:3000'
export default API_URL
